// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetPaymentSetupResponse

export type WidgetPaymentSetupApiResponse = {
	clientSecret: string;
	amount: number;
	connectedAccount: string | null;
};

export type WidgetPaymentSetup = {
	clientSecret: string;
	amount: number;
	connectedAccount: string | null;
};

export function hydrateWidgetPaymentSetup(data: WidgetPaymentSetupApiResponse): WidgetPaymentSetup {
	return { ...data };
}